import React from 'react';

enum ConversationHealthColor {
  Calculating = '#D9D9D9',
  VeryBad = '#E71111',
  Poor = '#EA5A0A',
  Okay = '#EFA00B',
  Good = '#41D3BD',
  Great = '#07BD71'
}

const getHealthColor = (health?: number): ConversationHealthColor => {
  if (health === undefined || health === null)
    return ConversationHealthColor.Calculating;
  if (health === 0) return ConversationHealthColor.Calculating;
  if (health >= 80) return ConversationHealthColor.Great;
  if (health >= 60) return ConversationHealthColor.Good;
  if (health >= 40) return ConversationHealthColor.Okay;
  if (health >= 20) return ConversationHealthColor.Poor;
  return ConversationHealthColor.VeryBad;
};

interface Props {
  health?: number;
}

function HealthScore({ health }: Props): React.ReactElement {
  const color = getHealthColor(health);
  const isCalculating = health === null || health === undefined;
  const layoutClass = isCalculating
    ? 'flex flex-col items-center gap-1 xl:flex-row xl:gap-2'
    : 'flex flex-row items-center gap-2';
  return (
    <div className={layoutClass}>
      <span
        className='h-4 w-4 shrink-0 rounded-full'
        style={{ backgroundColor: color }}
      />
      <span className='whitespace-nowrap text-sm leading-4'>
        {isCalculating ? 'Calculating...' : health}
      </span>
    </div>
  );
}

export default HealthScore;
